









































































import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import { AxiosError } from 'axios';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import { DateRange } from '@/components/DatePicker.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { PrepaidHistoryResponse, PrepaidHistory } from '../../libs/api.interfaces';

interface ReportParams {
  date: DateRange;
  status: LabelValue | null;
  type: LabelValue | null;
  id: string;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
  },
  methods: {
    format,
  },
})
export default class ReportTable extends Vue {
  channel = { title: '', code: '', path: '' };

  loading = true;
  history: PrepaidHistory[] = [];

  showFeeSharing = false;

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  format!: (val: number, cur?: boolean) => string;

  // eslint-disable-next-line class-methods-use-this
  openDetail(id: number) {
    window.open(`/auto-disbursement/account-statement/${id}`, '_blank');
  }

  mounted() {
    this.getFeeSharing();
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  async getTransaction(params: ReportParams, page = 1, isExport = false) {
    this.loading = true;

    try {
      const date = {
        startDate: params.date.startDate === null ? undefined
          : dayjs(params.date.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.date.endDate === null ? undefined
          : dayjs(params.date.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };

      const status = params.status === null || params.status.value === 'ALL' ? undefined : params.status.value;
      const action = params.type === null || params.type.value === 'ALL' ? undefined : params.type.value;
      const id = params.id === '' ? undefined : params.id;

      const { data } = await api.get<PrepaidHistoryResponse>('/prepaid/history', {
        params: {
          page,
          startDate: date.startDate,
          endDate: date.endDate,
          status,
          action,
          // eslint-disable-next-line @typescript-eslint/camelcase
          transaction_no: id,
          export: isExport || undefined,
        },
      });

      if (isExport) {
        const downloadData = data as unknown as { path: string };
        this.loading = false;
        return downloadData.path;
      }

      this.page = page;
      this.history = data.data;
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      return null;
    } catch (err) {
      console.error(err);

      if (isExport) {
        const error = err as AxiosError;
        console.log(error.response);
        showToast(ToastType.FAILED, 'Export Failed', error?.response?.data.error.message);
      }

      throw err;
    }
  }

  async export(params: ReportParams) {
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');

    try {
      const url = await this.getTransaction(params, 1, true);
      this.downloadSheet(url as string);
      showToast(ToastType.SUCCESS, 'Export Transaction', 'Export finished');
    } catch (err) {
      console.log(err);
      this.loading = false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadSheet(url: string) {
    const fileLink = document.createElement('a');
    fileLink.href = `${process.env.VUE_APP_API_URL}${url}`;

    document.body.appendChild(fileLink);
    fileLink.click();
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  getFeeSharing() {
    // eslint-disable-next-line max-len
    api.get('/disbursement/merchant/fee-sharing-configuration').then(({ data }) => {
      if (data) {
        this.showFeeSharing = data.show_fee_sharing;
      }
    });
  }
}
